  import React, { useEffect, useState } from 'react';
  import { pdf } from '@react-pdf/renderer';
  import MyDocument from './mydocument';
  import API_URL from '../config';
  import { ClipLoader } from 'react-spinners';


  // Add this at the very top of memberpdf.js (below the imports)
  const placeholderAvatar = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABWklEQVR4nO2XQYrCQBCGv4XehZfII3gFDxDP4XG8hT1CvEA8gD1Cj+AVPIJnkN04M4PMjDsTMqU/lBDSTXfV/1Xd1T0lZWVlZWVlZWVlZf2X4jAMs4+m6Rz5DbgAPx1V7j/AC/AAfAIXoOuoaxqGofcO2ALFGLgB07Vz6H3n5q1uGIYuY+Ar0APvOzb/L6A74N/ADQidQ+87N98AXZq5h+vQe8/Nd0B3uP62aXbI/eXmLs3cR+4vN3dp5j4C3SExXm7hN3B7uA6/hb+n/x34z2wAfqC/HPhfJIZeZgH8fTZAjP5S4H+RGJaZBPBrZ5q9zAT4h0wK+OtsgI/4XyWGYWbIe+zG8f8W/2eJYWbI77IbX7QzJIZeZga8y6TA/yIxLDM7oNfONHuZGfBvZ1q9TAz4gS49/6z/N/P9o6ysrKysrKysrPy/+QFZ6Zis233rLAAAAABJRU5ErkJggg==";


  const MemberPdf = () => {
    const [userData, setUserData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const baseUrl = API_URL;
    //const baseUrl = 'https://rmb.cognisunsandbox.com:4014/';
    // const baseUrl = 'http://localhost:4053/api/'  // Local

    useEffect(() => {
      fetchData();
      console.log("Path Name UUUVVV", window.location.pathname);
    }, []);

    useEffect(() => {
      if (userData.length > 0) {
        generatePdf();
      }
    }, [userData]);

    const checkImageExists = async (url) => {
      if(url == "" || url == null) return false
      try {
        const response = await fetch(url);
        if (response.ok) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    };

    // const fetchData = async () => {
    //   const url = new URL(window.location.href);
    //   const pathname = url.pathname;
    //   const parts = pathname.split('/');
    //   try {
    //     const response = await fetch(`${baseUrl}member/ListAllData`, {
    //       method: "POST",
    //       // body: JSON.stringify({
    //       //   status: parts[3],
    //       //   city: decodeURIComponent(parts[4]),
    //       //   CurrentUser: parts[2],
    //       // }),
    //       body: JSON.stringify({
    //       status: "Active",      // Default status
    //       city: "",              // Empty string loads all cities
    //       CurrentUser: parts[3], // personid is at parts[3]
    //     }),
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //       },
    //     });
    //     if (!response.ok) {
    //       throw new Error('Network response was not ok');
    //     }
    //     const data = await response.json();
    //     const updatedData = await Promise.all(
    //       data.data.map(async (value) => {
    //         const imageUrl = `${baseUrl}${value.profilepicture}`;
    //         const imageExists = await checkImageExists(imageUrl);
    //         value.profilepicture = imageExists
    //           ? imageUrl
    //           : "https://cdn-icons-png.freepik.com/512/8742/8742495.png";
    //         return value;
    //       })
    //     );
    
    //     setUserData(updatedData);
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // };
    
    // const generatePdf = async () => {
    //   setIsLoading(true);
    //   const currentUrl = new URL(window.location.href); // Initialize URL correctly
    //   const pathname = currentUrl.pathname;
    //   const parts = pathname.split('/');
    //   // const city = decodeURIComponent(parts[4]);
    //   const organizationName = decodeURIComponent(parts[2]); 
    //   const blob = await pdf(<MyDocument data={userData} />).toBlob();
    //   const url = URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   // link.download = `${city} ChapterRoster.pdf`;
    //   link.download = `${organizationName}_ChapterRoster.pdf`;
    //   link.click();
    //   URL.revokeObjectURL(url);
    //   setIsLoading(false);
    // };

    //   const fetchData = async () => {
    //   const url = new URL(window.location.href);
    //   const pathname = url.pathname;
    //   const parts = pathname.split('/');
      
    //   try {
    //     const response = await fetch(`${baseUrl}member/ListAllData`, {
    //       method: "POST",
    //       body: JSON.stringify({
    //         status: "Active",      // ✅ Fix: Hardcode 'Active' status
    //         city: "ALL",              // ✅ Fix: Pass empty string '' to get all cities
    //         CurrentUser: parts[3], // ✅ Fix: The Person ID is at index 3 in the URL
    //       }),
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //       },
    //     });
    //     if (!response.ok) {
    //       throw new Error('Network response was not ok');
    //     }
    //     const data = await response.json();
        
    //     // If no data returned, turn off loader so it doesn't spin forever
    //     if (!data.data || data.data.length === 0) {
    //       setIsLoading(false);
    //       alert("No members found in this chapter.");
    //       return;
    //     }

    //     // const updatedData = await Promise.all(
    //     //   data.data.map(async (value) => {
    //     //     const imageUrl = `${baseUrl}${value.profilepicture}`;
    //     //     const imageExists = await checkImageExists(imageUrl);
    //     //     value.profilepicture = imageExists
    //     //       ? imageUrl
    //     //       : "https://cdn-icons-png.freepik.com/512/8742/8742495.png";
    //     //     return value;
    //     //   })
    //     // );
    //     // ✅ OPTIMIZED: Bypass the slow checkImageExists fetches
    //     const updatedData = data.data.map((value) => {
    //       // If there is a profile picture, construct the URL, otherwise use the placeholder
    //       value.profilepicture = (value.profilepicture && value.profilepicture !== "null")
    //         ? `${baseUrl}${value.profilepicture}`
    //         : "https://cdn-icons-png.freepik.com/512/8742/8742495.png";
    //       return value;
    //     });
    
    //     setUserData(updatedData);
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //     setIsLoading(false); // ✅ Turn off loader on error
    //   }
    // };

      const fetchData = async () => {
      const url = new URL(window.location.href);
      const pathname = url.pathname;
      const parts = pathname.split('/');
      
      const targetOrgName = decodeURIComponent(parts[2]).trim().toLowerCase(); // e.g. "bpg"
      try {
        const response = await fetch(`${baseUrl}member/ListAllData`, {
          method: "POST",
          body: JSON.stringify({
            status: "Active",      
            city: "ALL",           
            CurrentUser: parts[3], 
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        
        if (!data.data || data.data.length === 0) {
          setIsLoading(false);
          alert("No members found in this chapter.");
          return;
        }
        // 1. Filter the data to only include members of this specific chapter (e.g. BPG)
        const filteredData = data.data.filter((value) => {
          const memberOrg = (value.organizationname || '').toString().trim().toLowerCase();
          return memberOrg === targetOrgName;
        });
        if (filteredData.length === 0) {
          setIsLoading(false);
          alert(`No members found for chapter: ${parts[2]}`);
          return;
        }
        // // 2. Since the list is now small (only BPG members), we can safely fetch their real photos and logos!
        // const updatedData = await Promise.all(
        //   filteredData.map(async (value) => {
        //     // Check and set Profile Picture
        //     const imageUrl = `${baseUrl}${value.profilepicture}`;
        //     const imageExists = await checkImageExists(imageUrl);
        //     value.profilepicture = imageExists
        //       ? imageUrl
        //       : "https://cdn-icons-png.freepik.com/512/8742/8742495.png";

          // ✅ TEMP FIX FOR TESTING: Limit to first 50 members so it loads instantly
        // const testLimitData = filteredData.slice(0, 50);
        // 2. Fetch photos and logos for the 50 members
        // 2. Fetch photos and logos for all chapter members
        const updatedData = await Promise.all(
          filteredData.map(async (value) => {  // ✅ Uses filteredData directly
            // Check and set Profile Picture
            const imageUrl = `${baseUrl}${value.profilepicture}`;
            const imageExists = await checkImageExists(imageUrl);
            value.profilepicture = imageExists
              ? imageUrl
              : "https://cdn-icons-png.freepik.com/512/8742/8742495.png";
            
            // Check and set Company Logo
            const logoUrl = `${baseUrl}${value.logo}`;
            const logoExists = await checkImageExists(logoUrl);
            value.logo = logoExists
              ? logoUrl
              : "/No_logo.png";
            return value;
          })
        );
        //       // 2. Fetch photos and logos for the 50 members
        // const updatedData = await Promise.all(
        //   testLimitData.map(async (value) => {
        //     // Check and set Profile Picture
        //     const imageUrl = `${baseUrl}${value.profilepicture}`;
        //     const imageExists = await checkImageExists(imageUrl);
        //     value.profilepicture = imageExists
        //       ? imageUrl
        //       : placeholderAvatar; // ✅ Change fallback here
            
        //     // Check and set Company Logo
        //     const logoUrl = `${baseUrl}${value.logo}`;
        //     const logoExists = await checkImageExists(logoUrl);
        //     value.logo = logoExists
        //       ? logoUrl
        //       : placeholderAvatar; // ✅ Change fallback here
        //     return value;
        //   })
        // );

    
        setUserData(updatedData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false); 
      }
    };


    const generatePdf = async () => {
      setIsLoading(true);
      const currentUrl = new URL(window.location.href);
      const pathname = currentUrl.pathname;
      const parts = pathname.split('/');
      
      // ✅ Fix: parts[2] is the organization name (e.g. BPG)
      const organizationName = decodeURIComponent(parts[2]); 
      const blob = await pdf(<MyDocument data={userData} />).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${organizationName}_ChapterRoster.pdf`;
      link.click();
      URL.revokeObjectURL(url);
      setIsLoading(false);
    };


    return (
      <div>
        {isLoading && (
          <div className="spinner-wrap">Please Wait...
            <ClipLoader color="#3366FF" size={90} borderWidth={5} />
          </div>
        )
      }
      </div>
    );
  };

  export default MemberPdf;
